import { ACCOUNTING_TAG } from '@futrli/shared-services';
import { useIntegrationsView } from '@futrli/views/hooks/useIntegrationsView';

import { filterIntregationsByTag } from './utils';

const tempSupportedProviders = ['sage', 'xero', 'qbo'];

export const useIntegrations = () => {
  const { integrations: catalog, isLoading } = useIntegrationsView();
  const integrations = catalog || [];
  const filteredIntegrations = filterIntregationsByTag(integrations, ACCOUNTING_TAG)
    .filter(integration => tempSupportedProviders.includes(integration.slug))
    .reverse();
  const excel = integrations.find(integration => integration.slug === 'excel');
  if (excel) {
    filteredIntegrations.push(excel);
  }

  return { integrations: filteredIntegrations, isLoading };
};
